import React, { useContext, useEffect, useState } from 'react';
import Layout from '../Component/layout/main-layout';
import { useTranslation } from 'react-i18next';
import { ArrowDropDown } from '@mui/icons-material';
import LotAngle from '../Images/LotAngle.svg'
import layoutBgImg from '../Images/layout/faq.jpg'
import { Context } from '../Store/context';
import { GetFaq } from '../api/Queries/get';
import Loading from '../Component/loader/loader';
import GlobalLayout from '../Component/layout/global-layout';

const Faq = () => {
  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [clickedId, setClickedId] = useState(null);
  const [faq, setFaq] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { showError } = useContext(Context);

  useEffect(() => {
    setIsLoading(true)
    const getNews = async () => {
      try {
        const data = await GetFaq()
        setIsLoading(false)
        setFaq(data)
      } catch (error) {
        showError(error.message);
        setIsLoading(false)
      }
    }
    getNews()
  }, [showError])

  const getQuestion = (laws) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return laws.rus_question;
    } else if (currentLang === 'en') {
      return laws.eng_question;
    }
    return laws.tm_question;
  };

  const getAnswer = (laws) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return laws.rus_answer;
    } else if (currentLang === 'en') {
      return laws.eng_answer;
    }
    return laws.tm_answer;
  };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    setClickedId(activeIndex === index ? null : index);
  };

  return (
    <GlobalLayout
      title={`${t('faq')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords="Kop soralyan soraglar, Köp soralýan soraglar, Часто задаваемые вопросы"
    >
      <div className='mb-20'>
        <Layout
          title={t('faq')}
          layoutBgImg={layoutBgImg}
        />
        <div className='w-full px-4 xxl:px-12 xxxl:px-32 xxxxl:px-64 
                      xxxxxl:px-[400px] xxxxxxl:px-[650px]
                      xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]'>

          <div className='bg-white dark:bg-dark-box mt-8'>
            {isLoading ? <Loading /> : <>
              {faq.map((item, index) => (
                <div key={item.id} className='overflow-hidden'>
                  <div
                    onClick={() => toggleAccordion(index)}
                    className={`cursor-pointer p-6 flex transition-all
                            duration-500 border-t-border
                            border-t ${index === 0 ? 'first:border-t-0' : ''}
                            justify-between items-center 
                            ${clickedId === index
                        ? 'focus:ring-2 focus:ring-indigo-500 dark:focus:ring-dark'
                        : 'border-transparent'}`}
                  >
                    <h2 className={`text-black dark:text-dark-text transition-colors flex
                              gap-4 duration-500 hover:text-primary
                              ${clickedId === index ? 'text-primary' : ''}`}
                    >
                      <img src={LotAngle} alt="undefined" />
                      {getQuestion(item)}
                    </h2>
                    <span className={`transform transition-transform duration-500 
                                  ${activeIndex === index ? 'rotate-180'
                        : 'rotate-0'}
                                `}
                    >
                      <ArrowDropDown className='text-blackOpacity dark:text-dark-text' />
                    </span>
                  </div>
                  <div
                    className={`transition-all duration-500 ease-in-out overflow-hidden 
                            ${activeIndex === index ? 'max-h-40 mb-2' : 'max-h-0'} 
                            px-6`}
                  >
                    {activeIndex === index && (
                      <p className='text-black dark:text-dark-text transition-opacity 
                                 border-l pl-6 border-l-primary duration-500 
                                 ease-in-out py-4'>
                        {getAnswer(item)}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </>}
          </div>
        </div>
      </div>
    </GlobalLayout>
  );
};

export default Faq;
